import React from 'react';
import { HeroSection } from './HeroSection';
import { EmotionalHook } from './EmotionalHook';
import { ProblemSection } from './ProblemSection';
import { SolutionSection } from './SolutionSection';
import { ComparisonSection } from './ComparisonSection';
import { OriginStory } from './OriginStory';
import { TestimonialsSection } from './TestimonialsSection';
import { ForYouSection } from './ForYouSection';
import { IncludesSection } from './IncludesSection';
import { GuaranteeSection } from './GuaranteeSection';
import { FinalCTA } from './FinalCTA';
import { PurchaseNotification } from './PurchaseNotification';
import { motion } from 'framer-motion';
export function SalesPage() {
  return <div className="min-h-screen bg-[#FDF8F4] font-sans" data-id="element-215">
      {/* Announcement Bar */}
      <div className="relative overflow-hidden bg-gradient-to-r from-red-600 via-rose-500 to-red-600 text-white text-center py-3 text-sm font-bold tracking-wide" data-id="element-216">
        <motion.div animate={{
        backgroundPosition: ['0% 50%', '100% 50%', '0% 50%']
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'linear'
      }} className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent bg-[length:200%_100%]" data-id="element-217" />
        <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-218">
          🔥 OFERTA ESPECIAL: 40% DE DESCUENTO + 2 BONUS GRATIS HOY 🔥
        </span>
      </div>

      <HeroSection data-id="element-219" />
      <EmotionalHook data-id="element-220" />
      <ProblemSection data-id="element-221" />
      <SolutionSection data-id="element-222" />
      <ComparisonSection data-id="element-223" />
      <OriginStory data-id="element-224" />
      <TestimonialsSection data-id="element-225" />
      <ForYouSection data-id="element-226" />
      <IncludesSection data-id="element-227" />
      <GuaranteeSection data-id="element-228" />
      <FinalCTA data-id="element-229" />

      <PurchaseNotification data-id="element-230" />

      {/* Simple Footer */}
      <footer className="bg-[#9B4D4D] text-white/60 py-12 text-center text-sm" data-id="element-231">
        <div className="max-w-7xl mx-auto px-4" data-id="element-232">
          <p data-id="element-233">© 2026 Calma-5™. Todos los derechos reservados.</p>
          <div className="mt-4 flex justify-center gap-6" data-id="element-234">
            <a href="#" className="hover:text-white transition-colors" data-id="element-235">
              Términos
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-236">
              Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-237">
              Contacto
            </a>
          </div>
        </div>
      </footer>
    </div>;
}